export const maskCPF = (value: string) => {
  return value
    .replace(/\D/g, "")
    .slice(0, 11)
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
};

export const maskPhone = (value: string) => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d)/, "$1-$2")
    .replace(/(-\d{4})\d+?$/, "$1");
};

export const maskDate = (value: string) => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1/$2")
    .replace(/(\d{2})(\d)/, "$1/$2")
    .replace(/(\/\d{4})\d+?$/, "$1");
};

export const maskCEP = (value: string, hasDot: boolean = true) => {
  const digits = value.replace(/\D/g, "").slice(0, 8);

  if (digits.length === 0) return "";

  if (hasDot) {
    if (digits.length <= 2) return digits;
    if (digits.length <= 5) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
    return `${digits.slice(0, 2)}.${digits.slice(2, 5)}-${digits.slice(5)}`;
  }

  if (digits.length <= 5) return digits;

  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
};

export const maskRG = (value: string) => {
  const digits = value.replace(/\D/g, "").slice(0, 15);
  const len = digits.length;

  if (len === 0) return "";
  if (len <= 3) return digits;

  const checkDigit = digits[len - 1];
  const main = digits.slice(0, len - 1);

  const groups: string[] = [];
  let remaining = main;
  while (remaining.length > 3) {
    groups.unshift(remaining.slice(-3));
    remaining = remaining.slice(0, -3);
  }
  groups.unshift(remaining);

  return `${groups.join(".")}-${checkDigit}`;
};

export const maskCpfOrCnpj = (value: string) => {
  const numbers = value.replace(/\D/g, "");

  if (numbers.length <= 11) {
    return numbers
      .slice(0, 11)
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  } else {
    return numbers
      .slice(0, 14)
      .replace(/(\d{2})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1/$2")
      .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
  }
};

export const maskCnpj = (value: string) => {
  const numbers = value.replace(/\D/g, "").slice(0, 14);

  if (numbers.length === 0) return "";
  if (numbers.length <= 2) {
    return numbers;
  }
  if (numbers.length <= 5) {
    return numbers.replace(/(\d{2})(\d{1,3})/, "$1.$2");
  }
  if (numbers.length <= 8) {
    return numbers.replace(/(\d{2})(\d{3})(\d{1,3})/, "$1.$2.$3");
  }
  if (numbers.length <= 12) {
    return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{1,4})/, "$1.$2.$3/$4");
  }
  return numbers.replace(
    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{1,2})/,
    "$1.$2.$3/$4-$5"
  );
};

export const maskCardExpirationDate = (value: string) => {
  // Remove todos os caracteres não numéricos
  const numbers = value.replace(/\D/g, "");

  // Limita a 4 dígitos (2 para mês e 2 para ano)
  const limitedNumbers = numbers.slice(0, 4);

  // Se tiver mais de 2 dígitos, adiciona a barra
  if (limitedNumbers.length > 2) {
    return `${limitedNumbers.slice(0, 2)}/${limitedNumbers.slice(2)}`;
  }

  return limitedNumbers;
};

export const maskDecimal82 = (value: string) => {
  // Trata a entrada como centavos, preenchendo da direita para a esquerda.
  // decimal(8,2) -> no máximo 8 dígitos (até 999999,99)
  const digits = value.replace(/\D/g, "").slice(0, 8);

  if (digits.length === 0) return "";

  const cents = parseInt(digits, 10);
  const reais = Math.floor(cents / 100);
  const decimals = String(cents % 100).padStart(2, "0");

  return `${reais},${decimals}`;
};

export const maskWeight = (value: string) => {
  let v = value.replace(/,/g, ".").replace(/[^\d.]/g, "");

  const firstDot = v.indexOf(".");
  if (firstDot !== -1) {
    v = v.slice(0, firstDot + 1) + v.slice(firstDot + 1).replace(/\./g, "");
  }

  const [intPart, decPart] = v.split(".");
  if (decPart !== undefined) v = `${intPart}.${decPart.slice(0, 3)}`;

  return v;
};

export const maskCardNumber = (value: string) => {
  // Remove todos os caracteres não numéricos
  const numbers = value.replace(/\D/g, "");

  // Limita a 16 dígitos
  const limitedNumbers = numbers.slice(0, 16);

  // Adiciona espaços a cada 4 dígitos
  return limitedNumbers.replace(/(\d{4})(?=\d)/g, "$1 ");
};
